import { Suspense, lazy, useCallback } from "react";
import { useBoolean } from "usehooks-ts";

import { LoadingScreen } from "components/LoadingScreen";
import { LOGO_FORM_SIZE } from "components/constants";
import { t } from "i18n/i18n";
import { SquareButton } from "mds/components/buttons/SquareButton";
import { ForumLogoIcon } from "mds/icons";
import { useHomeUrl } from "utils/hooks/use-home-url";
import { useNavigate } from "utils/routing";

const SystemCheck = lazy(() => import("components/av/SystemCheck"));

type LayoutProps = {
  openModal?: boolean;
};

export default function Layout({ openModal = false }: LayoutProps) {
  const {
    value: systemCheckIsOpen,
    setTrue: openSystemCheck,
    setFalse: closeSystemCheck,
  } = useBoolean(openModal);
  const navigate = useNavigate();
  const homeUrl = useHomeUrl();

  const onClose = useCallback(() => {
    closeSystemCheck();
    navigate(homeUrl);
  }, [closeSystemCheck, homeUrl, navigate]);

  if (systemCheckIsOpen) {
    return (
      <Suspense fallback={<LoadingScreen>{t("common.loading")}</LoadingScreen>}>
        <SystemCheck onClose={onClose} />
      </Suspense>
    );
  }

  return (
    <div className="flex-direction-column flex min-h-screen items-center justify-center p-4 text-left">
      <div className="m-2 w-full max-w-96">
        <div className="mb-3 flex items-center justify-between border-b border-black-tint-90 bg-white pb-1 text-black-tint-20">
          <span className="mb-2 flex cursor-pointer items-center">
            <ForumLogoIcon width={LOGO_FORM_SIZE} />
          </span>
        </div>
        <h2 className="mb-2">{t("av.system_check.title")}</h2>
        <span className="mb-2 flex cursor-pointer">
          <p> {t("av.system_check.entry_page_text")}</p>
        </span>
        <SquareButton kind="accent" size="m" onClick={openSystemCheck}>
          {t("av.system_check.start")}
        </SquareButton>
      </div>
    </div>
  );
}
